import { ExpressionRule } from "../../ExpressionRule";
import { ExpressionValue } from "../../ExpressionValue";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class AddExpression extends ExpressionRule {
    value1: ExpressionValue;
    value2: ExpressionValue;
    readonly __type: string = "Add";

    constructor() {
        super();
        this.value1 = ExpressionValue.createExpressionValue(this, "value1");
        this.value2 = ExpressionValue.createExpressionValue(this, "value2");
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return this.value1.evaluate(data, testContext) + this.value2.evaluate(data, testContext);
    }
}
